/**
 * Hand a blob to the browser as a download.
 *
 * The object URL is revoked on the next tick rather than immediately: the click has
 * been dispatched but the browser has not necessarily started reading the URL yet, and
 * revoking it in the same turn cancels the download in some browsers.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
